import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import React from 'react';

interface WhatsAppCTAProps {
  title: string;
  description: React.ReactNode;
  phoneNumber: string;
  message: string;
  buttonText: string;
  backgroundColor: string;
  buttonColor: string;
}

export const WhatsAppCTA: React.FC<WhatsAppCTAProps> = ({
  title,
  description,
  phoneNumber,
  message,
  buttonText,
  backgroundColor,
  buttonColor,
}) => {
  return (
    <motion.section
      className="py-20"
      style={{ backgroundColor }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8, delay: 1.0 }}
    >
      <div className="max-w-7xl mx-auto px-6 text-center">
        <h2 className="text-4xl font-bold mb-6" style={{ color: '#0A0F1C' }}>
          {title}
        </h2>
        <p
          className="text-xl mb-8 max-w-3xl mx-auto"
          style={{ color: '#64748B' }}
        >
          {description}
        </p>
        <motion.a
          href={`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center px-8 py-4 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transition-all duration-300"
          style={{ backgroundColor: buttonColor }}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          {buttonText}
          <ArrowRight size={20} className="ml-2" />
        </motion.a>
      </div>
    </motion.section>
  );
};
